import {BigDecimal, Money} from '@dms/api/shared';

export type CheckoutPrice = {
  withVat: Money;
  withoutVat?: Money | null;
  vat?: Money | null;
  vatRate?: BigDecimal | null;
};
